
import {defineComponent, PropType} from 'vue';
import {TopMenuItem} from './types';
import Icon from '@ohrm/oxd/core/components/Icon/Icon.vue';
import DropdownMenu from '@ohrm/oxd/core/components/DropdownMenu/DropdownMenu.vue';

export default defineComponent({
  name: 'oxd-navigation-link',
  props: {
    menuItem: {
      type: Object as PropType<TopMenuItem>,
    },
  },
  components: {
    'oxd-icon': Icon,
    'oxd-dropdown-menu': DropdownMenu,
  },
  setup() {
    const onClickMenu = ($event: MouseEvent, item: TopMenuItem) => {
      if (!item.children || item.children.length === 0) {
        window.location.replace(item.url);
      } else {
        $event.preventDefault();
        $event.stopPropagation();
      }
    };

    return {
      onClickMenu,
    };
  },
});
